import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import DeleteCategory from "../Categories/DeleteCategory";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { formatDate } from "../../Common/Utils/dateUtils";
import {
  deleteOneTicket,
  getAllTicketsListData,
} from "../../../redux/tickets/actions";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";

const Ticketslist = () => {
  const [params, setParams] = useState({
    search_key: "",
    page: 1,
  });
  const dispatch = useDispatch();
  const [currentComponent, setCurrentComponent] = useState({});
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const ticketsList = useSelector(
    (state) => state?.reusableSlice?.getTicketsList
  );

  useEffect(() => {
    dispatch(getAllTicketsListData(params))
      .then((res) => {
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }, [params, dispatch]);

  const updateComponent = (id) => {
    navigate(`/updateticket/${id}`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneTicket(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <div>
      <div className="p-3 ">
        <div className="category-wrapper d-flex justify-content-center flex-column w-100">
          <div className="d-flex justify-content-between align-items-center sub-head">
            <h4>Query List</h4>
            <button
              className="border-button"
              onClick={() => navigate("/addticket")}
            >
              <span>Create Query Topic</span>
            </button>
          </div>
        </div>
      </div>

      {isLoading ? (
  <FullScreenLoader />
) : ticketsList ? (
  <CardBody className="table-sec px-3">
    <table className="table">
      <thead>
        <tr>
          <th scope="col">Sl No</th>
          <th scope="col">Title</th>
          <th scope="col">Ar Title</th>
          <th scope="col">Position</th>
          <th scope="col">Status</th>
          <th>Create On</th>
          <th scope="col" style={{ textAlign: "center" }}>
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {ticketsList.all_ticket_category.length > 0 ? (
          ticketsList.all_ticket_category.map((item, index) => (
            <tr key={item.id || index}>
              <td>{index + 1 + (params?.page - 1) * 10}</td>
              <td>{item.title}</td>
              <td>{item.ar_title}</td>
              <td>{item.position}</td>
              <td style={{ color: item.status === 1 ? "green" : "red" }}>
                {item.status === 1 ? "Active" : item.status === 2 ? "Inactive" : ""}
              </td>
              <td>{formatDate(item.created_on)}</td>
              <td>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ columnGap: "10px" }}
                >
                  <button
                    className="border-button"
                    onClick={() => updateComponent(item.id)}
                  >
                    <span>Update</span>
                  </button>
                  <button
                    className="background-button"
                    onClick={() => {
                      setModal(true);
                      setCurrentComponent(item);
                    }}
                  >
                    <span> Delete</span>
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7" className="text-center">
              No Tickets Found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </CardBody>
) : (
  <CardBody className="table-sec px-3">
    <div className="text-center">
      <h5>No Data Found</h5>
    </div>
  </CardBody>
)}

      <CommonPagination
        params={params}
        setParams={setParams}
        pagination_meta={ticketsList?.pagination_meta}
      />

      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <DeleteCategory
          modalTitle="Ticket"
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        ></DeleteCategory>
      </Modal>
    </div>
  );
};

export default Ticketslist;
